<template>
  <table>
    <thead>
      <tr>
        <th class="text-center" :colspan="colspan">
          Recently Reviewed Films
        </th>
      </tr>
      <tr>
        <th>Title</th>
        <th v-if="!by">User</th>
        <th>Date</th>
        <th>Review</th>
      </tr> </thead>
    <tbody>
      <tr v-for="film in films" :key="film.id + '-' + film.user_id">
        <td>
          <router-link :to="links.filmLink(film)">
            {{ film.title }}
          </router-link>
        </td>
        <td v-if="!by">
          <router-link :to="links.userLink(+film.user_id)">
            {{ film.username }}
          </router-link>
        </td>
        <td>{{ $moment(film.date).fromNow() }}</td>
        <td>{{ utils.shorten(film.reviewed, 200) }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td :colspan="colspan">
          <v-pagination
            :length="Math.ceil(count/pageSize)"
            :total-visible="12"
            :value="page"
            @input="loadPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import links from "@/utils/Links"
import utils from "@/utils/utils"
import FilmRating from "@/components/details/FilmRating"

export default {
  name: "WatchedFilms",
  components: {
    FilmRating,
  },
  props: {
    by: {
      type: Number | String,
      default: "",
    },
  },
  data() {
    return {
      films: [],
      count: 0,
      page: 0,
    }
  },
  inject: ["httpClient"],
  mounted() {
    this.loadPage(1)
  },
  computed: {
    // TODO: better way to inject?
    links() {
      return links
    },
    utils() {
      return utils
    },
    // TODO: change to global config ( or user settings )
    pageSize() {
      return 10
    },
    me() {
      return this.$store.getters.me
    },
    colspan() {
      return this.by ? 3 : 4
    },
  },
  methods: {
    async loadPage(page) {
      const data = await this.httpClient.loadReviews({
        page,
        query: this.by ? {by: this.by} : {},
      })
      this.films = data.results
      this.page = data.page
      this.count = data.count
    },
  },
  watch: {
    by() {
      this.loadPage(1)
    },
  },
}
</script>
